import React from "react";
import * as ReactDOMClient from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import reactToWebComponent from "react-to-webcomponent";
import ReactDOM from "react-dom/client";
import { allowedDomains } from "./utils/constants";
const checkOrigin = (origin) => {
  if (allowedDomains.includes(origin)) {
    return true;
  } else {
    return false;
  }
};

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <div
//       // style={{ position: "fixed", bottom: "1rem", right: "1rem", zIndex: 9999 }}
//       style={{ position: "fixed", bottom: "1rem", right: "1rem", zIndex: 9999 }}
//     >
//       <App />
//       {/* {checkOrigin(window.location.ancestorOrigins[0]) && <App />} */}
//     </div>
//   </React.StrictMode>
// );

customElements.define(
  "df-chat",
  reactToWebComponent(App, React, ReactDOMClient)
);
